import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getCurrentUserId = createSelector(
  (state) => state.app.getIn(['currentUser', 'id']), res => res
);

export const getUserEmail = createSelector(
  (state) => state.app.getIn(['currentUser', 'emailAddress']), res => res
);

export const getInvitations = createDeepEqualSelector(
  (state) => state.invitations.getIn(['pendingInvites']).toJS(), res => res
);

export const getInvitation = createSelector(
  (state) => state.invitations.getIn(['invite']).toJS(), res => res
);

export const getPendingResponses = createSelector(
  (state) => state.invitations.getIn(['pendingResponses']), res => res
);

export const profileLoading = createSelector(
  (state) => state.app.getIn(['currentUser', 'profileLoading']), res => res
);
